import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EDUCATIONLEVEL,
  DELETE_EDUCATIONLEVEL,
  UPDATE_EDUCATIONLEVEL,
  ADD_NEW_EDUCATIONLEVEL,
} from "./actionType";

import {
  getEducationLevelSuccess,
  getEducationLevelFail,
  deleteEducationLevelSuccess,
  deleteEducationLevelFail,
  updateEducationLevelSuccess,
  updateEducationLevelFail,
  addEducationLevelSuccess,
  addEducationLevelFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEducationLevelApi,
  getEducationLevelApi,
  updateEducationLevelApi,
  deleteEducationLevelApi,
  addNewEducationLevelApi
} from "../../helpers/backend_helper";

function* getEducationLevel({ payload: educationLevel }) {
  try {
    const response = yield call(getEducationLevelApi, educationLevel);
    yield put(getEducationLevelSuccess(GET_EDUCATIONLEVEL, response.data));
  } catch (error) {
    yield put(getEducationLevelFail(GET_EDUCATIONLEVEL, error));
  }
}

function* onUpdateEducationLevel({ payload: educationLevel }) {
  try {
    const response = yield call(updateEducationLevelApi, educationLevel);
    yield put(updateEducationLevelSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateEducationLevelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEducationLevel({ payload: educationLevel }) {
  try {
    const response = yield call(deleteEducationLevelApi, educationLevel);
    yield put(deleteEducationLevelSuccess({ educationLevel, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEducationLevelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEducationLevel({ payload: educationLevel }) {
  try {
    const response = yield call(addNewEducationLevelApi, educationLevel);
    yield put(addEducationLevelSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEducationLevelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEducationLevel() {
  yield takeEvery(GET_EDUCATIONLEVEL, getEducationLevel);
}

export function* watchUpdateEducationLevel() {
  yield takeEvery(UPDATE_EDUCATIONLEVEL, onUpdateEducationLevel);
}

export function* watchDeleteEducationLevel() {
  yield takeEvery(DELETE_EDUCATIONLEVEL, onDeleteEducationLevel);
}

export function* watchAddNewEducationLevel() {
  yield takeEvery(ADD_NEW_EDUCATIONLEVEL, onAddNewEducationLevel);
}

function* educationLevelSaga() {
  yield all([
    fork(watchGetEducationLevel),
    fork(watchDeleteEducationLevel),
    fork(watchUpdateEducationLevel),
    fork(watchAddNewEducationLevel)
  ]);
}

export default educationLevelSaga;
